import { t } from 'app/i18l'
import { confirmAlert } from 'react-confirm-alert'
import 'react-confirm-alert/src/react-confirm-alert.css'

export function confirmationAlertWeb(
  title: string,
  message?: string
): Promise<boolean> {
  return new Promise(resolve => {
    confirmAlert({
      title,
      message,
      buttons: [
        {
          label: t('yes'),
          onClick: () => resolve(true),
        },
        {
          label: t('no'),
          onClick: () => resolve(false),
        },
      ],
    })
  })
}

export function errorAlertWeb(error: Error, title?: string) {
  confirmAlert({
    title: title ?? t('error'),
    message: error.message,
    buttons: [
      {
        label: 'OK',
      },
    ],
  })
}

export function informationAlertWeb(title: string, message: string) {
  confirmAlert({
    title,
    message,
    buttons: [
      {
        label: 'OK',
      },
    ],
  })
}
